import { HasId } from '../interfaces';
import { ScoreCardGroup } from '../models';
import { Organization } from './Organization';

export class ScoreCard implements HasId {
    public id: number;
    public name: string;
    public organization: Organization;
    public scoreCardGroups: ScoreCardGroup[];
}



// WEBPACK FOOTER //
// ./src/models/ScoreCard.tsx